import { useQuery } from '@tanstack/react-query';
import dashboardServices from '../services/dashboard.service'

/**
 * Reusable API error parser
 */
const parseApiError = (error) => {
  return {
    message:
      error?.response?.data?.message ||
      error?.response?.data?.error ||
      error?.message ||
      'Something went wrong',

    status: error?.response?.status || 500,

    errors: error?.response?.data?.errors || [],
  };
};

/**
 * Get dashboard stats
 */
export const useDashboardStats = () => {
  return useQuery({

    queryKey: ['dashboard-stats'],

    queryFn: async () => {
      try {

        return await dashboardServices.getDashboardStats();

      } catch (error) {

        throw parseApiError(error);
      }
    },

    staleTime: 30 * 1000, // 30 seconds

    gcTime: 5 * 60 * 1000, // 5 minutes

    placeholderData: (previousData) => previousData,

    retry: 1,

    refetchOnWindowFocus: true,
  });
};